import Jobs from "@/pages/Jobs";
import Leads from "@/pages/Leads";
import Login from "@/pages/Login";
import Move from "@/pages/Moves/index-columns";
import EditMove from "@/pages/EditMove";
import { RouteObject } from "react-router-dom";
import CompanyInformation from "@/pages/MoverSettings/CompanyInformation";
import { BasicConfiguration } from "@/pages/MoverSettings/BasicConfiguration";
import Fees from "@/pages/MoverSettings/Fees";
import Templates from "@/pages/MoverSettings/Templates";
import Dashboard from "@/pages/Dashboard";
import Documents from "@/pages/MoverSettings/Documents";
import Invoice from "@/pages/Moves/Invoice";
import Sales from "@/pages/MoverSettings/Sales";
import Conversations from "@/pages/Conversations";
import Crew from "@/pages/MoverSettings/Crew";
import { SendPaymentLink } from "@/pages/Moves/components/SendPaymentLink";
import Users from "@/pages/MoverSettings/Users";
import Trucks from "@/pages/MoverSettings/Trucks";
import Materials from "@/pages/MoverSettings/Materials";
import Onboarding from "@/pages/Onboarding";
import OperatingPolicies from "@/pages/MoverSettings/OperatingPolicies";
import LaborRates from "@/pages/MoverSettings/LaborRates";
import CalendarPage from "@/pages/Calendar";
import Timesheets from "@/pages/Timesheets/index";
import { Dispatch } from "@/pages/Dispatch";
import Payroll from "@/pages/Payroll";
import PayrollDetail from "@/pages/Payroll/Detail";
import PayrollEntryDetail from "@/pages/Payroll/EntryDetail";
import EditJob from "@/pages/EditJob";
import Payments from "@/pages/Payments";
import DripCampaigns from "@/components/DripCampaigns";

export const routes: RouteObject[] = [
  {
    path: "/",
    element: <Dashboard />,
  },
  {
    path: "/leads",
    element: <Leads />,
  },
  {
    path: "/move/new",
    element: <EditMove ts={Date.now()} />,
  },
  {
    path: "/job/new",
    element: <EditJob ts={Date.now()} />,
  },
  {
    path: "/move/:id",
    element: <Move />,
  },
  {
    path: "/job/:id",
    element: <Move />,
  },
  {
    path: "/move/:id/finalize",
    element: <Invoice />,
  },
  {
    path: "/move/:id/send-payment-link",
    element: <SendPaymentLink />,
  },
  {
    path: "/move/update/:id",
    element: <EditMove ts={Date.now()} />,
  },
  {
    path: "/job/update/:id",
    element: <EditJob ts={Date.now()} />,
  },
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/moves",
    element: <Jobs />,
  },
  {
    path: "/moves/calendar",
    element: <CalendarPage onDate={new Date()} />,
  },
  {
    path: "/calendar",
    element: <CalendarPage onDate={new Date()} />,
  },
  {
    path: "/dispatch",
    element: <Dispatch onDate={new Date()} />,
  },
  {
    path: "/moves/:view",
    element: <Jobs />,
  },
  {
    path: "/mover-settings/company-information",
    element: <CompanyInformation />,
  },
  {
    path: "/mover-settings/basic-configuration",
    element: <BasicConfiguration />,
  },
  {
    path: "/mover-settings/operating-policies",
    element: <OperatingPolicies />,
  },
  {
    path: "/mover-settings/labor-rates",
    element: <LaborRates />,
  },
  {
    path: "/mover-settings/fees",
    element: <Fees />,
  },
  {
    path: "/mover-settings/crew",
    element: <Crew />,
  },
  {
    path: "/mover-settings/materials",
    element: <Materials />,
  },
  {
    path: "/mover-settings/users",
    element: <Users />,
  },
  {
    path: "/mover-settings/documents",
    element: <Documents />,
  },
  {
    path: "/mover-settings/templates",
    element: <Templates />,
  },
  {
    path: "/mover-settings/sales",
    element: <Sales />,
  },
  {
    path: "/mover-settings/trucks",
    element: <Trucks />,
  },
  {
    path: "/mover-settings/drip-campaigns",
    element: <DripCampaigns leadStatus="initial" />,
  },
  {
    path: "/dashboard",
    element: <Dashboard />,
  },
  {
    path: "/messages",
    element: <Conversations />,
  },
  {
    path: "/inbox",
    element: <Conversations />,
  },
  {
    path: "/get-started",
    element: <Onboarding />,
  },
  {
    path: "/timesheets",
    element: <Timesheets />,
  },
  {
    path: "/payroll",
    element: <Payroll />,
  },
  {
    path: "/payroll/:id",
    element: <PayrollDetail />,
  },
  {
    path: "/payroll/:id/entry/:entryId",
    element: <PayrollEntryDetail />,
  },
  {
    path: "/payments",
    element: <Payments />,
  },
];
